import request from '@/utils/request'

const http = request()

export const savePrj = params => http.raw(params.nextStep ? '/project/hz/submit' : '/project/hz/save', params)

export const listPrj = params => http.post('/project/hz/list', params)

export const viewPrj = (projectId, isDetail = false) => (isDetail ? http.post('/project/hz/detail', { projectId }) : http.post('/project/hz/view', { projectId }))

export const reviewPrj = params => http.post('/project/hz/review', params)

export const stopPrj = projectId => http.post('/project/hz/stop', { projectId })

export const concludePrj = projectId => http.post('/project/hz/conclude', { projectId })

export const closePrj = projectId => http.post('/project/hz/close', { projectId })

export const getRaise = raiseId => http.post(`/project/raise/${raiseId}`, { raiseId })

export const getRaises = projectId => http.post('/project/raise/list', { projectId })

export const submitRaise = params => http.raw('/project/raise/submit', params)

export const reviewRaise = params => http.post('/project/raise/review', params)
